import { z } from 'zod';
import { MAX_TEXT_LENGTH } from './text';

/** Rewrites can grow to three times the original text's length. */
export const MAX_SPEECH_LENGTH = MAX_TEXT_LENGTH * 3;
const MAX_SPEECH_CHUNK_LENGTH = 4_096;

export const SpeechRequestSchema = z
  .strictObject({ text: z.string().trim().min(1).max(MAX_SPEECH_LENGTH) })
  .meta({ id: 'SpeechRequest' });

/** Fits OpenAI's speech input limit, preferring word boundaries. */
export function splitSpeechText(text: string): string[] {
  const chunks: string[] = [];
  let remaining = text.trim();
  while (remaining.length > MAX_SPEECH_CHUNK_LENGTH) {
    const candidate = remaining.slice(0, MAX_SPEECH_CHUNK_LENGTH);
    const boundary = [...candidate.matchAll(/\s+/gu)]
      .map((match) => match.index + match[0].length)
      .filter((index) => index >= MAX_SPEECH_CHUNK_LENGTH / 2)
      .at(-1);
    // Never divide a surrogate pair when a long run has no word boundary.
    const end =
      boundary ?? (/[\uD800-\uDBFF]$/.test(candidate) ? candidate.length - 1 : candidate.length);
    chunks.push(remaining.slice(0, end).trim());
    remaining = remaining.slice(end).trimStart();
  }
  if (remaining) chunks.push(remaining);
  return chunks;
}
